import React from 'react';

interface Props {
    text: string | undefined
}

const ErrorBox = ({text}: Props) => {

    if (!text || text.length === 0) {
        return <></>;
    }

    return (
        <div className={"errorBox"}>
            <span>{text}</span>
        </div>
    )
}

export default ErrorBox;